import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/unidade-executante-manutencao`

    return {
        unidade: {
            autocomplete(queryParms = {}) {
                return repository.get(`${baseUrl}/autocomplete-unidade?${urlUtil.serialize(queryParms)}`)
            },
        },
        fornecedor: {
            autocomplete(queryParms = {}) {
                return repository.get(`${baseUrl}/autocomplete-fornecedor?${urlUtil.serialize(queryParms)}`)
            },
        },
        datatable(queryParms = {}) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
    }
}